import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TarefasService } from 'src/app/tarefas/service/tarefas.service';
import { ModalMensagemComponent } from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { FiltroSelectBuscaComponent } from 'src/app/shared/components/filtro-select-busca/filtro-select-busca.component';
import { FiltroSelectOption } from 'src/app/shared/components/filtro-select/filtro-select.component';
import { CommonLoaderComponent } from '../../common-loader/common-loader.component';

@Component({
  selector: 'app-criar-tarefa',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CommonLoaderComponent,
    ModalMensagemComponent,
    FiltroSelectBuscaComponent,
  ],
  templateUrl: './criar-tarefa.component.html',
  styleUrls: ['./criar-tarefa.component.scss'],
})
export class CriarTarefaComponent implements OnInit {
  @Input() contatoInfo?: {
    id?: number;
    nome?: string;
    cargo?: string;
    email?: string;
  };

  @Input() obrasPredefinidas?: { workID: number; workName: string; moduleId?: number | null }[];
  @Input() moduloId: number | null = null;
  
  @Output() fechar = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();
  @Output() tarefaCriada = new EventEmitter<any>();

  userId: string;
  description = '';
  data = '';
  hora = '';
  responsibleID: number | string = '';
  actionID = '';
  responsavel: any[] = [];
  tarefas: any[] = [];
  obras: { workID: number; workName: string; moduleId?: number | null; moduleID?: number | null }[] = [];

  tarefaCriadaSucesso: boolean = false;
  campoObrigatorioErro: boolean = false;
  carregandoTarefas: boolean = false;

  today: string = new Date().toISOString().split('T')[0];
  selectedObra: number | '' | null = null;
  private resultadoCriacao: any = null;

  constructor(private readonly _tarefaService: TarefasService) {
    this.userId = localStorage.getItem('userId');
  }

  opcoesObras: FiltroSelectOption[] = [];
  opcoesResponsaveis: FiltroSelectOption[] = [];

  ngOnInit(): void {
    this.popularResponsavelObra();
    this.popularAcao();

    if (this.obrasPredefinidas) {
      this.obras = this.obrasPredefinidas;
      this.opcoesObras = this.obras.map((obra) => ({ value: obra.workID, label: obra.workName }));

      if (this.obras.length === 1) {
        this.selectedObra = this.obras[0].workID;
      }
    } else {
      this.listarObras();
    }
  }

  criarTarefa() {
    if (this.carregandoTarefas) {
      return;
    }

    this.campoObrigatorioErro = false;
    if (!this.responsibleID || !this.actionID) {
      this.campoObrigatorioErro = true;
      console.error('Erro: Campos obrigatórios não preenchidos');
      return;
    }

    if (!this.selectedObra) {
      console.error('Erro: ID da obra não definido');
      this.campoObrigatorioErro = true;
      this.loading.emit(false);
      return;
    }

    const body = {
      ActionID: Number(this.actionID),
      FollowUp: this.formatFollowUp(this.data, this.hora),
      ResponsibleID: Number(this.responsibleID),
      Description: this.description,
      workID: this.selectedObra,
      isEdited: false,
      contactID: this.contatoInfo?.id ?? null,
    };
    this.carregandoTarefas = true;

    const obraSelecionada = this.obras.find((o) => o.workID === this.selectedObra);
    const moduloIdObra = obraSelecionada?.moduleId ?? obraSelecionada?.moduleID ?? this.moduloId;

    this._tarefaService.createTask(this.selectedObra, body, moduloIdObra).subscribe({
      next: (res) => {
        this.loading.emit(false);
        this.resultadoCriacao = res;
        this.tarefaCriadaSucesso = true;
        this.carregandoTarefas = false;
      },
      error: (err) => {
        this.carregandoTarefas = false;
        console.error('Erro ao criar tarefa:', err);
      },
    });
  }

  fecharSucesso() {
    this.tarefaCriadaSucesso = false;
    this.tarefaCriada.emit(this.resultadoCriacao);
  }

  fecharModal() {
    this.fechar.emit();
  }

  formatFollowUp(date: string, time: string): string {
    if (!date || !time) return '';
    const [yyyy, mm, dd] = date.split('-');
    let horaFormatada = time.length === 5 ? `${time}:00` : time;
    return `${dd}/${mm}/${yyyy} ${horaFormatada}`;
  }

  popularResponsavelObra(): void {
    this._tarefaService.listResponsables().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
        this.opcoesResponsaveis = this.responsavel.map((r) => ({ value: r.id, label: r.name }));
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  popularAcao(): void {
    this._tarefaService.listActions().subscribe(
      (response) => {
        this.tarefas = response.data.sort((a, b) =>
          a.description.localeCompare(b.description),
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  listarObras(): void {
    this._tarefaService.listWorks().subscribe(
      (response) => {
        this.obras = response.data;
        this.opcoesObras = this.obras.map((obra) => ({ value: obra.workID, label: obra.workName }));
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  limparCampos() {
    this.description = '';
    this.data = '';
    this.hora = '';
    this.responsibleID = '';
    this.actionID = '';
    this.selectedObra = null;
    this.campoObrigatorioErro = false;
  }
}
